import { algoliaApiSearch } from 'algolia-api/algoliaApiSearch';
import { algoliaApiGetSearchConfig } from 'algolia-api/search/algoliaApiGetSearchConfig';
import { algoliaApiGetSearchIndex } from 'algolia-api/search/algoliaApiGetSearchIndex';
import getSearchLocationOptions from 'algolia-api/search/getSearchLocationOptions';
import { QueryOptions } from 'algolia-api/types/QueryOptions';
import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';
import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { ApiJobFunction } from 'api/types/ApiJobFunction';

type ResultItem = {
  objectID: string;
  name: string;
  city: string;
  state: string;
  logo: ApiFilestackImageData;
  orgName: string;
  url: string;
};

const ATTRIBUTES: (keyof ResultItem)[] = [
  'objectID',
  'name',
  'city',
  'state',
  'logo',
  'orgName',
  'url',
];

type Props = {
  searchLocation: Partial<SearchLocation> &
    Pick<SearchLocation, 'latitude' | 'longitude'>;
  options: {
    onlyWithLogo: boolean;
    jobFunction?: ApiJobFunction | null | undefined;
    areaOfFocus?: ApiAreaOfFocus | null | undefined;
    jobTitle?: string;
    locale?: string;
    familyId?: string;
    query?: string;
  };
  searchOptions?: QueryOptions;
};

export async function algoliaApiGetRecommendedJobs({
  searchLocation,
  options: {
    onlyWithLogo,
    jobFunction,
    areaOfFocus,
    locale,
    jobTitle,
    familyId,
  },
  searchOptions,
}: Props) {
  const searchConfig = algoliaApiGetSearchConfig();
  let locationOptions = {};

  if (searchLocation && searchLocation.latitude && searchLocation.longitude) {
    locationOptions = getSearchLocationOptions(
      'auto',
      searchLocation,
    ).locationOptions;
  }

  const filters = [
    onlyWithLogo && '_tags:hasLogo',
    jobFunction && `(functions:'${jobFunction}')`,
    areaOfFocus && `(areasOfFocus: '${areaOfFocus}')`,
    locale && `(locale: '${locale}')`,
    familyId && `(compdb.familyId:'${familyId}')`,
  ]
    .filter(Boolean)
    .join(' AND ');

  const queryOptions: QueryOptions = {
    index: algoliaApiGetSearchIndex(),
    hitsPerPage: 20,
    attributesToRetrieve: ATTRIBUTES as string[],
    facetFilters: [['type:JOB']],
    filters,
    query: jobTitle,
    ...locationOptions,
    ...searchOptions,
  };
  return algoliaApiSearch<ResultItem>({
    config: searchConfig,
    query: '',
    queryOptions,
  }).then(({ hits }) => hits);
}
